module.exports = __webpack_public_path__ + "static/media/tax.3b4596fc.png";